import axios from "axios";
import { ApiUrl, header } from "../../utils/modules";
// import { header } from "../utils/modules";

class AuthServices {
    login(credentials) {
      //console.log(credentials);
      // Ajoutez un return ici pour s'assurer que la promesse est bien retournée
      return axios.post(`${ApiUrl}auth/login`, credentials);
    }
  

//   register(credentials) {
//     return axios.post(`${ApiUrl}auth/register`, credentials);
//   }

  checkToken(token) {
    return axios.get(`${ApiUrl}auth/me`, { headers: { Authorization: `Bearer ${token}` } });
  }

//   update(credentials, id) {
//     return axios.patch(`${ApiUrl}user/${id}`, credentials, header());
//   }

updatePassword(id, passwordData) {
  return axios.patch(`${ApiUrl}auth/updateMyPassword/${id}`, passwordData, header());
}


  logout() {
    return axios.post(`${ApiUrl}auth/logout`);
  }

  forgotPassword(email) {
  return axios.post(`${ApiUrl}auth/password/forgot`, { email });
}

resetPassword(token, passwordData) {
  return axios.patch(`${ApiUrl}auth/password/reset/${token}`, passwordData);
}
}

export default new AuthServices();